module.exports = __webpack_public_path__ + "img/new_index_cases3.20894ef0.png";